import React from 'react';
import { Table, FormControl } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';

import s from './LocationList.css';
import messages from '../../../../locale/messages';
import Link from '../../../Link';
import EditIcon from '../../../../../public/Icons/edit.png';
import addIcon from '../../../../../public/Icons/addNewIcon.svg';
import { updateLocationStatus } from '../../../../actions/siteadmin/Location/manageLocation';
import { FaFilter, FaPenAlt, FaPencilAlt, FaSlidersH } from 'react-icons/fa';

class LocationList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            searchList: '',
            typingTimeout: 0,
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleStatus = this.handleStatus.bind(this);
    }

    handleSearchClick(searchList) {
        const { locationDetails: { refetch } } = this.props;
        this.setState({ currentPage: 1 });
        refetch({ currentPage: 1, searchList });
    }

    handleSearchChange(e) {
        if (this.state.typingTimeout) clearTimeout(this.state.typingTimeout);
        this.setState({
            searchList: e.target.value,
            typingTimeout: setTimeout(() => this.handleSearchClick(this.state.searchList), 450),
        });
    }

    async handleStatus(e, id) {
        const { updateLocationStatus, locationDetails: { refetch } } = this.props;
        const { currentPage } = this.state;
        const isActive = e.target.value === 'true';

        const response = await updateLocationStatus(id, isActive);
        if (response && response.status === 200) {
            refetch({ currentPage });
        }
    }

    render() {
        const { locationDetails } = this.props;
        const { formatMessage } = this.props.intl;

        const locations = locationDetails?.getAllLocationsAdmin?.results;

        return (
            <div className={cx(s.widthInner, s.tableSection, 'whiteDropdown', 'widthInnerNoBorder')}>
                <div className={cx(s.exportDisplay, s.tabelExport)}>
                    <div className={'textAlignRightRTL'}>
                        <div className={s.searchInput}>
                            <FormControl
                                type='text'
                                placeholder={formatMessage(messages.search)}
                                onChange={this.handleSearchChange}
                                className={s.formControlInput}
                            />
                        </div>
                    </div>
                    <div className={cx(s.exportTextSection, 'textAlignLeftRTL')}>
                        <div className={cx(s.paddingTop2)}>
                            <Link to={'/siteadmin/location/add'} className={s.addlinkBtn}>
                                {formatMessage(messages.addLocationHeading)}
                                <span className={cx(s.addIconCss, 'addIconCssRTL')}>
                                    <img src={addIcon} alt='add location' />
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewAdminResponsiveTable')}>
                    <Table className={cx('table')}>
                        <thead>
                            <tr>
                                <th scope="col"><FormattedMessage {...messages.id} /></th>
                                <th scope="col"><FormattedMessage {...messages.locationNameLabel} /></th>
                                <th scope="col"><FormattedMessage {...messages.locationDescription} /></th>
                                <th scope="col"><FormattedMessage {...messages.status} /></th>
                                <th scope="col"><FormattedMessage {...messages.action} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {locations && locations.length > 0 ? (
                                locations.map((item) => (
                                    <tr key={item.id}>
                                        <td data-label={formatMessage(messages.id)}>{item.id}</td>
                                        <td data-label={formatMessage(messages.locationNameLabel)}>{item.locationName}</td>
                                        <td data-label={formatMessage(messages.locationDescription)}>{item.description}</td>
                                        <td data-label={formatMessage(messages.status)}>
                                            <select
                                                value={item.isActive}
                                                onChange={(e) => this.handleStatus(e, item.id)}
                                                className={s.selectInput}
                                            >
                                                <option value={true}>{formatMessage(messages.active)}</option>
                                                <option value={false}>{formatMessage(messages.inactive)}</option>
                                            </select>
                                        </td>
                                        <td data-label={formatMessage(messages.action)} className={s.minWidth}>
                                            <div className='d-flex gap-2'>
                                                <Link
                                                    to={`/siteadmin/location/edit/${item.id}`}
                                                    className={cx('btn btn-light btn-sm d-inline-flex gap-2 align-items-center')}
                                                >
                                                    <FaPencilAlt />
                                                    <span className={s.vtrMiddle}>
                                                        <FormattedMessage {...messages.editAction} />
                                                    </span>
                                                </Link>
                                                <Link
                                                    to={`/siteadmin/location/${item.id}/services`}
                                                    className={cx('btn btn-light btn-sm d-inline-flex gap-2 align-items-center')}
                                                >
                                                    <FaSlidersH />
                                                    <span className={s.vtrMiddle}>
                                                        <FormattedMessage {...messages.manageServices} />
                                                    </span>
                                                </Link>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className={s.noRecord}>
                                        <FormattedMessage {...messages.noResult} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { updateLocationStatus };

export default withStyles(s)(injectIntl(connect(mapStateToProps, mapDispatchToProps)(LocationList)));
